import { type FC } from 'react'
import { Form } from 'react-bootstrap'
import { isPartialRedtailSelection, REDTAIL_NOT_CONFIGURED_LABEL, REDTAIL_UNSET, type RedtailOption, redtailSelectValue } from './eventConfig'

interface RedtailSelectProps {
  id: string
  label: string
  value: string
  options: RedtailOption[]
  onChange: (id: string) => void
}

const RedtailSelect: FC<RedtailSelectProps> = ({ id, label, value, options, onChange }) => (
  <div className='d-flex flex-column zocks-gap-0.25'>
    <label className='bold' htmlFor={id}>
      {label}
    </label>
    <Form.Select id={id} value={redtailSelectValue(value, options)} onChange={(event) => onChange(event.currentTarget.value)}>
      <option value={REDTAIL_UNSET} disabled>
        {REDTAIL_NOT_CONFIGURED_LABEL}
      </option>
      {options.map((option) => (
        <option key={option.id} value={option.id}>
          {option.label}
        </option>
      ))}
    </Form.Select>
  </div>
)

interface RedtailActivityMatchFieldsProps {
  idPrefix: string
  activityCodeId: string
  categoryId: string
  activityCodeOptions: RedtailOption[]
  categoryOptions: RedtailOption[]
  onActivityCodeChange: (id: string) => void
  onCategoryChange: (id: string) => void
}

export const RedtailActivityMatchFields: FC<RedtailActivityMatchFieldsProps> = ({
  idPrefix,
  activityCodeId,
  categoryId,
  activityCodeOptions,
  categoryOptions,
  onActivityCodeChange,
  onCategoryChange,
}) => (
  <div className='d-flex flex-column zocks-gap-0.25'>
    <span className='bold'>Activity match</span>
    <span className='paragraph-small zocks-text-gray-600'>Choose the Redtail activity type this event should sync as.</span>
    <div className='d-flex gap-3'>
      <RedtailSelect id={`${idPrefix}-activity-code`} label='Type' value={activityCodeId} options={activityCodeOptions} onChange={onActivityCodeChange} />
      <RedtailSelect id={`${idPrefix}-category`} label='Category' value={categoryId} options={categoryOptions} onChange={onCategoryChange} />
    </div>
    {isPartialRedtailSelection(activityCodeId, categoryId) ? (
      <span className='paragraph-small zocks-text-danger'>Choose both a type and a category.</span>
    ) : null}
  </div>
)
